import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  label: {
    display: "block"
  },
  root: {
    marginLeft: "5px",
    marginRight: "5px"
  }
});

export default function DisaggFooter(props) {
  const classes = useStyles();
  return (
    <div className="disagg-feedback">
      <div className="feedback-head">{props.translations.data["DISAGG101.FOOTER_TITLE"]}</div>
      <div className="like-dislike-container">
        <div className="fbody">
          <Button
            className="thumbs-up"
            classes={{ label: classes.label, root: classes.root }}
            onClick={props.thumbsUpClick}
          >
            <span className="feedback-icon bidgely-icon-thumbs-up"></span>
            <div className="feedback-text">{props.translations.data["DISAGG101.FOOTER_TEXT_YES"]}</div>
          </Button>
          <Button
            className="thumbs-down"
            classes={{ label: classes.label, root: classes.root }}
            onClick={props.thumbsDownClick}
          >
            <span className="feedback-icon bidgely-icon-thumbs-down"></span>
            <div className="feedback-text">{props.translations.data["DISAGG101.FOOTER_TEXT_NO"]}</div>
          </Button>
        </div>
      </div>
    </div>
  );
}
